const { BOOLEAN } = require('../primitives');

const boolean = {
  ...BOOLEAN,
};

module.exports = boolean;
